import * as React from 'react';
import { st, classes } from './Modal.st.css';
import { MODAL_DATA_HOOKS } from './dataHooks';
import { KEY_CODES } from '../../../common/keyCodes';
import { createPortal } from 'react-dom';
import { TPAComponentsConsumer, TPAComponentsContext, } from '../../../../../esm/components/TPAComponentsConfig';
import * as _focusTrap from 'focus-trap';
export const Modal = ({ className, shouldCloseOnClickOutside = true, shouldCloseOnEsc = true, focusTrap = true, isOpen = false, forceBWTheme = false, appendToBody = false, onRequestClose, children, 'data-hook': dataHook, }) => {
    const { mobile: isMobile } = React.useContext(TPAComponentsContext);
    const contentRef = React.useRef(null);
    React.useEffect(() => {
        if (!isMobile && isOpen && shouldCloseOnEsc) {
            document.addEventListener('keyup', onEscKeyup);
            return () => document.removeEventListener('keyup', onEscKeyup);
        }
        return undefined;
    }, [isOpen, isMobile, shouldCloseOnEsc]);
    // @ts-expect-error
    React.useEffect(() => {
        if (isOpen && focusTrap && contentRef.current) {
            const focusTrapInstance = _focusTrap.createFocusTrap(contentRef.current, {
                escapeDeactivates: false,
                clickOutsideDeactivates: shouldCloseOnClickOutside,
                returnFocusOnDeactivate: true,
            });
            try {
                focusTrapInstance.activate();
            }
            catch (err) { }
            return () => focusTrapInstance.deactivate();
        }
        return undefined;
    }, [isOpen, focusTrap]);
    const onEscKeyup = (e) => {
        if (e.keyCode === KEY_CODES.Esc) {
            onClose();
        }
    };
    const onClose = () => onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose();
    const renderModal = () => (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.overlay, "data-hook": MODAL_DATA_HOOKS.OVERLAY, onClick: shouldCloseOnClickOutside ? onClose : undefined }),
        React.createElement("section", { className: classes.modal, "data-hook": MODAL_DATA_HOOKS.CONTENT, ref: contentRef }, children)));
    const modalComponent = (React.createElement(TPAComponentsConsumer, null, () => (React.createElement("div", { "data-hook": dataHook, className: st(classes.root, { isOpen, forceBWTheme }, className) }, isOpen ? renderModal() : null))));
    return appendToBody && typeof document !== 'undefined'
        ? createPortal(modalComponent, document.body)
        : modalComponent;
};
Modal.displayName = 'Modal';
//# sourceMappingURL=Modal.js.map